/**
 * Returns the complete banner notification state
 *
 * @param {object} state - Current state
 * @returns {object} - The entire banner notification state
 */
function getBannerNotificationsState(state) {
  const toRet = {
    bannerNotifications: state.notifications.bannerNotifications,
    activeMessage: state.notifications.activeMessage,
    freeCreditAware: state.notifications.freeCreditAware,
  };
  return toRet;
}

export default getBannerNotificationsState;
